import logoReamar from "./img/reamar.png";

const logoReamarStyle = {
  maxWidth: "100%",
  height: "auto",
  padding: 0,
  margin: 0,
};

const rowStyle = {
  width: "100%",
  height: "80%",
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
};

const containerStyle = {
  height: "100vh",
};

export default function BlankPage({ ...props }) {
  return (
    <div style={containerStyle}>
      <div className="row" style={rowStyle}>
        <div className="col-md-8 col-md-offset-2">
          <img src={logoReamar} style={logoReamarStyle} alt="Logo Reamar" />
        </div>
      </div>
    </div>
  );
}
